:host {
  display: block;
  margin-bottom: 20px;
}

.color-swatches {
  align-items: stretch;
  display: flex;
  flex-flow: row wrap;
  gap: 24px 16px;
}

.color-swatch {
  border: 2px solid #000000;
  border-radius: 5px;
  padding: 16px 8px;
  width: calc(25% - 16px);
}

.color-swatch__color {
  background-color: #bada55;
  display: block;
  height: 150px;
  width: 100%;
}

.color-swatch__title {
  line-height: 1.2;
  margin: 8px 0;
}

.color-description {
  margin: 16px 0;
}
